import { ConfigProvider } from 'antd'
import 'antd/dist/reset.css'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import App from './App'
import './i18n'
import './index.less'
import reportWebVitals from './reportWebVitals'
import { PersistGate } from 'redux-persist/integration/react'
import { persistor, store } from './store/index'
import { GoogleOAuthProvider } from '@react-oauth/google'
import { CLIENT_ID } from './constants/GoogleAuth'

const antdGlobalStyle = {
  token: {
    colorPrimary: 'rgba(75,75,75,1)',
    colorPrimaryHover: 'rgba(75,75,75,.8)',
    colorPrimaryActive: 'rgba(75,75,75,.8)'
  }
}
const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <ConfigProvider theme={antdGlobalStyle}>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <GoogleOAuthProvider clientId={CLIENT_ID}>
          <App />
        </GoogleOAuthProvider>
      </PersistGate>
    </Provider>
  </ConfigProvider>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
